import React, { useState, useEffect } from 'react';

interface Props {
    value: number;
    duration?: number;
    className?: string;
}

const AnimatedNumber: React.FC<Props> = ({ value, duration = 800, className }) => {
    const [display, setDisplay] = useState(0);
    useEffect(() => {
        if (value === 0) { setDisplay(0); return; }
        let start = 0;
        const step = Math.max(1, Math.ceil(value / (duration / 16)));
        const interval = setInterval(() => {
            start += step;
            if (start >= value) { setDisplay(value); clearInterval(interval); }
            else setDisplay(start);
        }, 16);
        return () => clearInterval(interval);
    }, [value, duration]);
    return <span className={className}>{display.toLocaleString()}</span>;
};

export default AnimatedNumber;
